import { toast } from 'react-toastify';
import { updateCoachExpertise } from '../../services/apiService';

export const profileVerificationActionTypes = {
  SET_PROFILE_TO_VERIFY: 'SET_PROFILE_TO_VERIFY',
  VERIFY_PROFILE: 'VERIFY_PROFILE',
};

export const setProfileToVerify = (user) => {
  return {
    type: profileVerificationActionTypes.SET_PROFILE_TO_VERIFY,
    payload: user,
  };
};

export const verifyProfile = ({ coachId, payload }) => {
  return async (dispatch) => {
    try {
      await updateCoachExpertise({
        coachId,
        payload,
      });
      dispatch(setProfileToVerify(null));
    } catch (e) {
      toast.error('Error loading Coaches');
    }
  };
};
